export const MASKED_INPUT_TYPE = {
  NUMBER: 'NUMBER',
  PHONE: 'PHONE',
  DATE: 'DATE',
  TEXT: 'TEXT',
};

export const FORBIDDEN_KEYCODES = [37, 38, 39, 40];
